import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NavbarComponent } from './navbar/navbar.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { SharedMasterDataService } from './_services/shared-master-data/shared-master-data.service';
import { UserService } from './_services/user/user.service';

@Component({
  selector: 'app-secure',
  imports: [CommonModule, NavbarComponent, TranslateModule, MatIconModule],
  standalone: true,
  templateUrl: './secure.component.html',
  styleUrl: './secure.component.scss'
})
export class SecureComponent {
  currentYear: number = new Date().getFullYear();

  constructor(private masterData: SharedMasterDataService ) {}

  ngOnInit() {
    // Load master data only after authentication is confirmed
    this.masterData.loadAllMasterData();
  }
}
